import iconMap from "src/assets/icons/Icons";
import { ThemeBasedColorHeader } from "src/shared/modules/profile/theme/themeCheacker";

interface PopupProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
  buttonTrue?: boolean;
  back?: boolean;
  onBack?: () => void;
  className?: string;
}

export default function PopupModules({
  isOpen,
  onClose,
  title,
  children,
  back = false,
  onBack,
  className = "", // ✅ safe default
}: PopupProps) {
  const { Back } = iconMap;

  if (!isOpen) return null;

  return (
    <div className={`w-full h-full fixed inset-0 flex items-center justify-center z-50 backdrop-blur-sm`}>
      <div
        className={`min-w-[400px] max-w-[90%] max-h-[90%] rounded-2xl shadow-md border relative flex flex-col ${ThemeBasedColorHeader()} ${className} `}
      >
        {/* Close Button */}
        <button onClick={onClose} className={`absolute top-1.5 right-3 text-2xl font-bold hover:text-red-500 `}>
          ×
        </button>

        <div className='flex w-full'>
          {back && (
            <button className=' px-1' onClick={onBack}>
              <Back />
            </button>
          )}

          {/* Header */}
          {title && <h1 className={`text-center text-2xl font-semibold my-1 py-2 ml-4 `}>{title}</h1>}
        </div>

        {/* Content (scrollable) */}
        <div className={`w-full overflow-y-auto px-4 py-2 rounded-b-2xl bg-white text-black h-full`}>{children}</div>
      </div>
    </div>
  );
}
